module.exports = __webpack_public_path__ + "img/icon_ystg.cf353b62.png";